// extracted by mini-css-extract-plugin
module.exports = {"modal":"MultiPlayersModal_modal__6s3Aw"};